module.exports = __webpack_public_path__ + "img/border_large_braces.db493cc1.svg";